/**
 * Copyright by INSIDE M2M GmbH and the authors 2004 - 2018
 *
 *************************************************************
 ********************* CONFIDENTIAL **************************
 *************************************************************
 *
 */

import { Type } from '@angular/core';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Deprecated operator. Use `ofType` as it is now typesafe with `@ngrx/store/createAction`.
 * @deprecated
 * @param allowedClasses
 */
export function ofClass<R extends Action>(allowedClasses: Type<R>): (source: Observable<Action>) => Observable<R>;
export function ofClass<R1 extends Action, R2 extends Action>(
    allowedClass1: Type<R1>,
    allowedClass2: Type<R2>
): (source: Observable<Action>) => Observable<R1 | R2>;
export function ofClass<R1 extends Action, R2 extends Action, R3 extends Action>(
    allowedClass1: Type<R1>,
    allowedClass2: Type<R2>,
    allowedClass3: Type<R3>
): (source: Observable<Action>) => Observable<R1 | R2 | R3>;
export function ofClass<R1 extends Action, R2 extends Action, R3 extends Action, R4 extends Action>(
    allowedClass1: Type<R1>,
    allowedClass2: Type<R2>,
    allowedClass3: Type<R3>,
    allowedClass4: Type<R4>
): (source: Observable<Action>) => Observable<R1 | R2 | R3 | R4>;
export function ofClass<R1 extends Action, R2 extends Action, R3 extends Action, R4 extends Action, R5 extends Action>(
    allowedClass1: Type<R1>,
    allowedClass2: Type<R2>,
    allowedClass3: Type<R3>,
    allowedClass4: Type<R4>,
    allowedClass5: Type<R5>
): (source: Observable<Action>) => Observable<R1 | R2 | R3 | R4 | R5>;
export function ofClass(...allowedClasses: Array<Type<any>>) {
    return (source: Observable<Action>) => {
        return source.pipe(filter((action: Action) => allowedClasses.some((allowedClass) => action instanceof allowedClass)));
    };
}
